/**
 * Singleton accessor for the one app-shell-level CartDrawer instance,
 * matching the plain-module-state style mapIntent.ts already uses for its
 * own hand-off. Instantiated once in main.ts (not page-scoped the way the
 * old AgentDrawer was) - pages reach it through this module rather than
 * router.ts growing into general-purpose singleton storage, which isn't
 * its job.
 */
import type { CartDrawer } from '../components/CartDrawer';

let instance: CartDrawer | null = null;

export function setCartDrawer(drawer: CartDrawer): void {
  instance = drawer;
}

export function getCartDrawer(): CartDrawer | null {
  return instance;
}
